/**
 * Router component
 */
import Container from '@components/atoms/container/routerContainer';
import Mask from '@components/elements/background/backgroundSelector';
import Menu from '@components/sections/menu/menu';
import TopBar from '@components/elements/topBar/topBar';
import { selectRoute } from '@shared/store/slices/router.slice';
import { useAppSelector } from '@shared/store/hooks';

/**
 * This component renders the menu and the current page.
 * @returns {React.ReactNode}
 */
export default function Router() {
  const { Page } = useAppSelector(selectRoute);
  return (
    <Container>
      <Menu />
      <TopBar />
      <Mask />
      <Page />
    </Container>
  );
}
